export default __webpack_public_path__ + "static/media/direct_print_disable.b02d3944.svg";